module.exports = __webpack_public_path__ + "img/AL.7db5994a.svg";